import { http } from '../../utils/http'
export const QCBASE = window.$envUtils('VUE_APP_QC_SERVICE')

export const getQcPlanList = (params) => {
  return http.get(`${QCBASE}/mgr/plan/qcPlans`, { params }, function () {})
}

export const getQcPlanById = (params) => {
  return http.get(`${QCBASE}/mgr/plan/qcPlan`, { params }, function () {})
}

export const getQcPlanByName = (params) => {
  return http.get(`${QCBASE}/mgr/plan/qcPlanByName`, { params }, function () {})
}

export const saveQcPlan = (data) => {
  return http.post(`${QCBASE}/mgr/plan/qcPlan`, { data }, function () {})
}

export const updateQcPlan = (data) => {
  return http.put(`${QCBASE}/mgr/plan/qcPlan`, { data }, function () {})
}

export const deleteQcPlan = (id) => {
  return http.delete(`${QCBASE}/mgr/plan/qcPlan/` + id)
}
